import { useEffect } from 'react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { CUSTOMERS_PAGE_TABS } from '@/data/constants'
import { getLastRoutePath } from '@/utils/route-utils'

const CustomersPageLayout = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const selectedTab = getLastRoutePath(pathname)

  useEffect(() => {
    if (selectedTab === 'customers') navigate('all-customers')
  }, [selectedTab, navigate])

  return (
    <div className="md:px-[10%] md:pt-[2%] bg-bgGray min-h-screen h-auto p-5" data-testid="customers-page-container">
      <div className="flex flex-col md:gap-8 gap-5">
        <div className="flex justify-between items-center">
          <p className="text-2xl md:text-3xl/[38px] font-semibold text-[--gray-900]">Customers</p>
        </div>
        {/* Defines Customers tab*/}
        <div className="md:gap-2 md:border-b md:block relative">
          <div className="flex flex-row gap-3">
            <div className="md:flex hidden gap-3">
              {Object.entries(CUSTOMERS_PAGE_TABS).map(([key, tab]) => (
                <Link key={key} to={key}>
                  <div
                    className={cn(
                      selectedTab === key ? 'border-solid border-b-2 border-[--brand-600]' : null,
                      'px-1 pb-3'
                    )}
                  >
                    <div
                      className={`text-sm font-semibold px-0 ${
                        selectedTab === key ? 'text-brand-700' : 'text-dGray-500'
                      }`}
                    >
                      {tab.title}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
        {/* Render the child routes */}
        <Outlet />
      </div>
    </div>
  )
}

export default CustomersPageLayout
